// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uq-0";